// extracted by mini-css-extract-plugin
export var header = "ListHeader-module--header--V3rdb";
export var imageSection = "ListHeader-module--imageSection--7XU3F";
export var label = "ListHeader-module--label--4McEC";
export var large = "ListHeader-module--large--JJo5C";